import { render } from "./hesap-olustur.vue?vue&type=template&id=4663f578"
import script from "./hesap-olustur.vue?vue&type=script&lang=js"
export * from "./hesap-olustur.vue?vue&type=script&lang=js"

import exportComponent from "/home/B2BServer/b2bPortal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__